// Put all hooks for on dom loaded event here
$(function() {
  IbQuestionbank.UI.onDoomLoaded();


  $(document).on('turbo:load', function() {
    IbQuestionbank.UI.onDoomLoaded();
  }); 
});
